import { Injectable } from '@angular/core';
import { Policy } from '../models/policy';

@Injectable({
  providedIn: 'root',
})
export class PolicyService {
  policies: Policy[] = [];
  constructor() {
    this.buildPoicies();
  }

  isRoleInPolicy(policyName: string, roleName: string): boolean {
    var currentPolicy = this.policies.find((a) => a.Name == policyName);
    if (currentPolicy) {
      if (currentPolicy.Roles.find((r) => r == roleName)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  rolesForPolicy(policyName: string): string[] | undefined {
    var currentPolicy = this.policies.find((a) => a.Name == policyName);
    return currentPolicy?.Roles;
  }

  private buildPoicies() {
    this.policies.push({
      Name: 'ApplicationUser',
      Roles: new Array(
        'DfsOversight',
        'DfsAdmin',
        'DfsUser',
        'ValleyUser',
        'ZimmaticUser'
      ),
    });
    this.policies.push({
      Name: 'QuoteHistory',
      Roles: new Array('DfsOversight', 'DfsAdmin', 'DfsUser'),
    });
    this.policies.push({
      Name: 'UserAdministration',
      Roles: new Array('DfsOversight', 'DfsAdmin'),
    });
    this.policies.push({
      Name: 'AdminOversight',
      Roles: new Array('DfsOversight'),
    });
  }
}
